import "@/errorFilter";
import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

// Fonts – lokal ausgeliefert (DSGVO: kein Google-Fonts-Nachladen)
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/space-grotesk/500.css";
import "@fontsource/space-grotesk/600.css";
import "@fontsource/space-grotesk/700.css";
import "@fontsource/ibm-plex-mono/400.css";
import "@fontsource/ibm-plex-mono/500.css";

import "@/index.css";
import App from "@/App";
import { PwaProvider } from "@/context/PwaContext";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <PwaProvider>
        <App />
      </PwaProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);

// Service-Worker-Registrierung erfolgt zentral im PwaProvider (Updates/Kontrolle).
